import { WidgetProps } from '@rjsf/core';
import CodeEditor from '.';

const JSEditor = (props: WidgetProps) => {
    return (
        <>
            {props?.schema?.title}
            <CodeEditor language="javascript" value={props.value} onChange={props.onChange} />
        </>
    );
};

export default JSEditor;
